import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=9c9abf9c&scoped=true&"
import script from "./DraggableList.vue?vue&type=script&lang=js&"
export * from "./DraggableList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableList.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./DraggableList.vue?vue&type=style&index=1&id=9c9abf9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9abf9c",
  null
  
)

export default component.exports